import { createPortal } from 'react-dom';
import type { MutableRefObject } from 'react';
import EndTimeForeverPicker from './EndTimeForeverPicker';
import TimeGroup from './TimeGroup';
import dayjs from 'lib/dayjs';
import useSmartField from 'hooks/useSmartField';

type TypeDayPickerImplProps = {
  hookRef: MutableRefObject<null>;
  fieldNamePrefix: string;
  value?: DayValue;
  onChange?: (value: DayValue) => void;
};

type DayValue = {
  dtRange:
    | {
        startAt: string | undefined;
        endAt: string | undefined;
      }
    | undefined;
  dayRepeat:
    | {
        startAt: string;
        endAt: string;
      }[]
    | undefined;
};

function TypeDayPickerImpl(props: TypeDayPickerImplProps) {
  const { hookRef, fieldNamePrefix } = props;
  const { field: sdtField, helpers: stdHelper } = useSmartField(
    `${fieldNamePrefix}.activeDuration`,
  );

  if (!hookRef.current) {
    return null;
  }

  return (
    <>
      <EndTimeForeverPicker
        noForever
        value={
          sdtField?.value?.startAt
            ? [
                dayjs(sdtField?.value?.startAt, 'YYYY-MM-DD HH:mm'),
                dayjs(sdtField?.value?.endAt, 'YYYY-MM-DD HH:mm'),
              ]
            : undefined
        }
        onChange={(value) => {
          const startAt = value?.[0];
          const endAt = value?.[1];
          stdHelper.setValue({
            startAt,
            endAt,
          });
        }}
      />
      {createPortal(
        <TimeGroup fieldNamePrefix={`${fieldNamePrefix}.dayRepeat.0.timeRanges`} />,
        hookRef.current!,
      )}
    </>
  );
}

export default TypeDayPickerImpl;
